import { PlusOutlined } from '@ant-design/icons';
import { Button, Space, Spin } from 'antd';
import Title from 'antd/es/typography/Title';
import Context from 'app/config/context';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import OrgChart from 'app/shared/util/org-chart/chart-container';
import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import OrganizationUpdate from '../form/organization-update';
import { deleteEntity, getEntities } from '../organization.reducer';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';

export const Organization = () => {
  const dispatch = useAppDispatch();
  const organizationList = useAppSelector(state => state.organization.entities);
  const loading = useAppSelector(state => state.organization.loading);

  const [isOpen, setOpen] = useState(false);
  const [isSameOrganization, setSameOrganization] = useState(false);
  const [parentActive, setParentActive] = useState(null);
  const [itemSelected, setItemSelected] = useState(null);
  const [sourceData, setSourceData] = useState(null);
  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  useEffect(() => {
    setSourceData(organizationList[0]);
  }, [organizationList]);

  const handleChangeCollapsed = (idItemsCollapsed, item) => {
    if (item.children && item.children.length > 0) {
      item.children.forEach(element => {
        if (idItemsCollapsed.includes(element.id)) {
          element.isCollapsed = !element.isCollapsed;
        } else {
          handleChangeCollapsed(idItemsCollapsed, element);
        }
      });
      return item;
    }
  };

  const handleOpenModalAddItemOrg = (item, type) => {
    setParentActive(item);
    setSameOrganization(parseInt(type, 10) === 1 ? true : false);
    setOpen(true);
  };

  const handleOpenModalUpdateItemOrg = item => {
    setItemSelected(item);
    setOpen(true);
  };

  const handleOpenModalAddRootItemOrg = () => {
    setOpen(true);
  };

  const handleCloseModalItemOrg = () => {
    setOpen(false);
    setItemSelected(null);
    setParentActive(null);
  };

  const handleConfirmDelete = () => {
    if (itemSelected && itemSelected.id) {
      dispatch(deleteEntity(itemSelected.id))
        .then(() => {
          dispatch(getEntities({}));
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };

  const handleWarningDeleteItem = value => {
    setVisibleConfirmDelete(true);
    setItemSelected(value);
  };

  return (
    <Context.Provider
      value={{
        handleOpenModalAddItemOrg,
        handleOpenModalUpdateItemOrg,
        handleCloseModalItemOrg,
        handleOpenModalConfirmDeleteItem: handleWarningDeleteItem,
      }}
    >
      <Container className="view">
        <Spin spinning={loading} delay={500}>
          <Title level={3}>Mô hình tổ chức</Title>
          {!sourceData && (
            <Space className=" d-flex justify-content-center">
              <Button
                size="large"
                onClick={() => {
                  handleOpenModalAddRootItemOrg();
                }}
                className="primary"
                icon={<PlusOutlined />}
              >
                Thêm mới sơ đồ tổ chức
              </Button>
            </Space>
          )}
          {sourceData && <OrgChart dataSource={sourceData} />}
          <OrganizationUpdate
            id={itemSelected?.id}
            isSameOrg={isSameOrganization}
            isOpen={isOpen}
            parent={parentActive}
            onCancel={handleCloseModalItemOrg}
          />
        </Spin>
        <ModalConfirmComponent
          visible={visibleConfirmDelete}
          onCancel={() => {
            setVisibleConfirmDelete(false);
          }}
          onConfirm={handleConfirmDelete}
          title={`Bạn có muốn xóa "${itemSelected?.orgName}"`}
        />
      </Container>
    </Context.Provider>
  );
};

export default Organization;
